
const translations = {
  // Navigation
  "nav.inicio": "Home",
  "nav.sobre": "About",
  "nav.tours": "Tours",
  "nav.servicos": "Services",
  "nav.contacto": "Contact",
  "nav.reservar": "Book Now",

  // Hero
  "hero.title1": "Discover",
  "hero.title2": "Madeira",
  "hero.title3": "With Us",
  "hero.description": "Guided tours, transfers and unique experiences on Madeira Island. Explore the lush nature, stunning landscapes and local culture with safety and comfort.",
  "hero.verServicos": "View Services",
  "hero.saberMais": "Learn More",

  // Booking Form
  "booking.title": "Quick Booking",
  "booking.tipoServico": "Service type",
  "booking.selecioneServico": "Select a service",
  "booking.transfers": "Transfers",
  "booking.levadas": "Levadas & Trails",
  "booking.toursFoto": "Photo Tours",
  "booking.data": "Date",
  "booking.pessoas": "People",
  "booking.pessoa": "person",
  "booking.pessoasPlural": "people",
  "booking.telefone": "Phone / WhatsApp",
  "booking.pedirReserva": "Request Booking",
  "booking.aProcessar": "Processing...",
  "booking.sucesso": "Request sent successfully!",
  "booking.sucessoMsg": "We will contact you soon.",
  "booking.erro": "An error occurred. Please try again.",

  // About
  "about.tag": "About Us",
  "about.title1": "Your",
  "about.title2": "Adventure",
  "about.title3": "in Madeira Starts Here",
  "about.p1": "We are a tourism company specialized in tours and transfers on Madeira Island. With over 15 years of experience, we know every corner of this paradise island and want to share its beauty with you.",
  "about.p2": "Our team of professional drivers ensures safe, comfortable and unforgettable experiences. From the famous levadas to the most spectacular viewpoints, we create memories that last forever.",
  "about.anos": "Years of Experience",
  "about.turistas": "Tourists",
  "about.satisfacao": "Satisfaction",
  "about.destinos": "Destinations",

  // Services
  "services.tag": "Services",
  "services.title1": "Our",
  "services.title2": "Services",
  "services.description": "We offer a variety of tours and services to make your visit to Madeira unforgettable.",
  "services.saberMais": "Learn more",
  "services.transfers.title": "Transfers",
  "services.transfers.desc": "Comfortable and safe transfer service from the airport to the hotel and vice versa. Also available for trips between tourist spots.",
  "services.levadas.title": "Levadas & Trails",
  "services.levadas.desc": "Hikes along the famous levadas of Madeira. Explore the lush nature and unique landscapes of the island safely.",
  "services.foto.title": "Photo Tours",
  "services.foto.desc": "Capture the best moments of Madeira in the most photogenic locations. Ideal for photography enthusiasts.",

  // Tours
  "tours.tag": "Tours",
  "tours.title1": "Our",
  "tours.title2": "Tours",
  "tours.description": "Choose from our most popular tours and discover the best of Madeira Island. Available at two daily schedules for your convenience.",
  "tours.itinerario": "Itinerary",
  "tours.duracao": "Duration",
  "tours.grupo": "Group",
  "tours.ate": "Up to",
  "tours.precos": "Prices per group:",
  "tours.ate4": "Up to 4 people",
  "tours.5a8": "5 to 8 people",
  "tours.inclui": "Includes:",
  "tours.transporte": "Transport",
  "tours.escolhaHorario": "Choose Schedule",
  "tours.manha": "Morning",
  "tours.tarde": "Afternoon",
  "tours.tour1.title": "Madeira Island Tour - Between Viewpoints and Typical Villages",
  "tours.tour1.subtitle": "Nature & Adventure",
  "tours.tour1.desc": "Be enchanted by the coast of Madeira, where the famous colorful houses of Santana catch your attention. Explore viewpoints that reveal breathtaking landscapes and discover the tranquility of various villages.",
  "tours.tour2.title": "Madeira Panorama - Tour Between Viewpoints",
  "tours.tour2.subtitle": "Landscapes & Culture",
  "tours.tour2.desc": "This tour takes participants on a journey through the most impressive landscapes of Madeira, passing through viewpoints and typical villages.",

  // Tour Booking Modal
  "tourModal.title": "Book Tour",
  "tourModal.sucesso": "Booking Sent!",
  "tourModal.sucessoMsg": "We will contact you soon to confirm your booking.",
  "tourModal.nome": "Full Name",
  "tourModal.nomePlaceholder": "Your name",
  "tourModal.email": "Email",
  "tourModal.telefone": "Phone / WhatsApp",
  "tourModal.confirmar": "Confirm Booking",

  // Testimonials
  "testimonials.tag": "Testimonials",
  "testimonials.title1": "What Our",
  "testimonials.title2": "Clients Say",
  "testimonials.t1.name": "Carlos Silva",
  "testimonials.t1.role": "Tourist from Lisbon",
  "testimonials.t1.text": "Incredible experience! The levada tour was fantastic and the guide very professional. Highly recommend for anyone visiting Madeira.",
  "testimonials.t2.name": "Sophie Martin",
  "testimonials.t2.role": "Tourist from France",
  "testimonials.t2.text": "The dolphin watching trip was magical! The team was very attentive and the transfer service impeccable. We will definitely return!",

  // CTA
  "cta.title": "Ready For Your Adventure in Madeira?",
  "cta.description": "Book now your tour or transfer and discover why Madeira is known as the Pearl of the Atlantic.",
  "cta.reservar": "Book Now",

  // Contact
  "contact.tag": "Contact",
  "contact.title1": "Let's",
  "contact.title2": "Plan",
  "contact.title3": "Your Trip",
  "contact.description": "Contact us to book your tour or transfer. We are available to answer all your questions and create the perfect experience in Madeira.",
  "contact.email": "Email",
  "contact.telefone": "Phone / WhatsApp",
  "contact.localizacao": "Location",
  "contact.nome": "Name",
  "contact.nomePlaceholder": "Your name",
  "contact.assunto": "Subject",
  "contact.assuntoPlaceholder": "Ex: Tour Booking, Transfer, Information...",
  "contact.mensagem": "Message",
  "contact.mensagemPlaceholder": "Tell us about the tour or transfer you want to book...",
  "contact.enviar": "Send Message",
  "contact.aEnviar": "Sending...",
  "contact.sucesso": "Message sent successfully! We will contact you soon.",
  "contact.erro": "An error occurred. Please try again.",

  // Footer
  "footer.description": "Tourism company specialized in guided tours and transfers on Madeira Island. Authentic and unforgettable experiences since 2010.",
  "footer.linksRapidos": "Quick Links",
  "footer.redesSociais": "Social Media",
  "footer.direitos": "© 2025 Madeira Tours & Transfers. All rights reserved.",

  // Music
  "music.pausar": "Pause music",
  "music.reproduzir": "Play music"
};

export default translations;
